import { ChangeDetectionStrategy, Component } from '@angular/core';
import { DEFAULT_CONTRAST } from '../../../../cross-team-shared/state/layer-settings-state-2d';
import { AbstractViewSettingsImageSliderComponent } from './abstract-view-settings-image-slider-component.directive';

@Component({
  selector: 'h3-view-settings-contrast-slider',
  templateUrl: './view-settings-contrast-slider.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: false,
})
export class ViewSettingsContrastSliderComponent extends AbstractViewSettingsImageSliderComponent {
  override readonly settingName = 'contrast';
  defaultContrast = DEFAULT_CONTRAST;
}
